var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "u-clear" }, [
    _c("div", { staticClass: "title u-clear" }, [
      _c("p", { staticClass: "u-fl" }, [_vm._v("Text")]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "u-fr",
          on: {
            click: function($event) {
              return _vm.remove()
            }
          }
        },
        [_c("icon-delete")],
        1
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "u-fr",
          class: { disabled: _vm.last },
          on: {
            click: function($event) {
              return _vm.backwards()
            }
          }
        },
        [_c("icon-down")],
        1
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "u-fr",
          class: { disabled: _vm.first },
          on: {
            click: function($event) {
              return _vm.forwards()
            }
          }
        },
        [_c("icon-up")],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "u-fl field small" },
      [
        _c("label", { staticClass: "label" }, [_vm._v("Left")]),
        _vm._v(" "),
        _c("ui-number", {
          attrs: { value: _vm.active.left },
          on: {
            change: function($event) {
              return _vm.prop("left", $event)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "u-fl field small" },
      [
        _c("label", { staticClass: "label" }, [_vm._v("Top")]),
        _vm._v(" "),
        _c("ui-number", {
          attrs: { value: _vm.active.top },
          on: {
            change: function($event) {
              return _vm.prop("top", $event)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "u-fl field small" },
      [
        _c("label", { staticClass: "label" }, [_vm._v("Scale X")]),
        _vm._v(" "),
        _c("ui-number", {
          attrs: { value: _vm.active.scaleX },
          on: {
            change: function($event) {
              return _vm.prop("scaleX", $event)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "u-fl field small" },
      [
        _c("label", { staticClass: "label" }, [_vm._v("Scale Y")]),
        _vm._v(" "),
        _c("ui-number", {
          attrs: { value: _vm.active.scaleY },
          on: {
            change: function($event) {
              return _vm.prop("scaleY", $event)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "u-fl field medium" },
      [
        _c("label", { staticClass: "label" }, [_vm._v("Font family")]),
        _vm._v(" "),
        _c("ui-select", {
          attrs: { value: _vm.active.fontFamily, options: _vm.fonts },
          on: {
            change: function($event) {
              return _vm.prop("fontFamily", $event)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "u-fl field micro" },
      [
        _c("label", { staticClass: "label" }, [_vm._v("Font size")]),
        _vm._v(" "),
        _c("ui-number", {
          attrs: { value: _vm.active.fontSize },
          on: {
            change: function($event) {
              return _vm.prop("fontSize", $event)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "u-fl field small" },
      [
        _c("label", { staticClass: "label" }, [_vm._v("Font style")]),
        _vm._v(" "),
        _c("ui-select", {
          attrs: {
            value: _vm.active.fontWeight + "," + _vm.active.fontStyle,
            options: _vm.fontStyles
          },
          on: {
            change: function($event) {
              return _vm.font($event)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "u-fl field small" },
      [
        _c("label", { staticClass: "label" }, [_vm._v("Text align")]),
        _vm._v(" "),
        _c("ui-select", {
          attrs: { value: _vm.active.textAlign, options: _vm.textAligns },
          on: {
            change: function($event) {
              return _vm.prop("textAlign", $event)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "u-fl field large" },
      [
        _c("label", { staticClass: "label" }, [_vm._v("Color")]),
        _vm._v(" "),
        _c("ui-color", {
          attrs: { value: _vm.active.fill },
          on: {
            change: function($event) {
              return _vm.prop("fill", $event)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }